import { useParams, Navigate } from "react-router-dom";
import BlogsAndReports from "../HomeNew/blogs-and-reports";
import Testimonials from "../shared/testimonials";
import HowWeHelp from "./how-we-help";
import IndustryHero from "./industry-hero";
import IndustryOverView from "./IndustryOverView";
import KeySolutions from "./logistics";
import KeySegments from "./key-segments";
import Conversation from "./conversation";
import { industryDummyData } from "../../data/industry-data/index";
import { useEffect } from "react";

const IndustryPage = () => {
  const { slug } = useParams();

  // Find the industry data matching the slug
  const industryData = industryDummyData.find((item) => item.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!industryData) {
    // Optionally redirect or show 404. For now, if no slug (e.g. /industry-det), maybe show first or null
    if (!slug) {
      // Fallback for dev purposes if accessing /industry-det directly without slug,
      // though in production we expect /industries/:slug
      return (
        <Navigate to={`/industries/${industryDummyData[0].slug}`} replace />
      );
    }
    return <div>Industry not found</div>;
  }

  return (
    <>
      <IndustryHero
        title={industryData.title}
        subTitle={industryData.subTitle}
        bgImage={industryData.bgImage}
      />
      <IndustryOverView overviewData={industryData.industryOverview} />
      <KeySegments data={industryData.industryOverview?.keySegments} />
      <HowWeHelp helpItems={industryData.howWeHelp} />
      <KeySolutions
        title={industryData.title} // Passing title to extract industry name if needed
        data={industryData.keySolutions}
      />
      <BlogsAndReports description={industryData.industryInsights} />
      {/* <Testimonials description={industryData.testimonialSubTitle} /> */}
      <Conversation
        industryName={industryData.title} // Pass name for potential customization
        conversationSubTitle={industryData.conversationSubTitle}
      />
    </>
  );
};

export default IndustryPage;
